import {
  ButtonIcon,
  TextField,
  Typography,
} from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { messageAwaitingApprovalActionsAtom } from '../../../atoms/messages';
import useApi, { API_ENDPOINTS } from '../../../hooks/api';
import Confirm from '../../Confirm';

const FAILED_QA = 'FAILED_QA';

export function RejectVideo({ currentStatus, size, videoKey }) {
  const api = useApi();
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(false);
  const [reason, setReason] = useState('');

  const setActionMessage = useSetAtom(messageAwaitingApprovalActionsAtom);

  const rejectVideo = async () => {
    const data = JSON.stringify({
      comments: reason,
      status: FAILED_QA,
    });
    const response = await api.patch(
      `${API_ENDPOINTS.videoService}/videos/${videoKey}`,
      {
        data,
      },
    );

    const successText = intl.formatMessage(
      {
        defaultMessage: 'Rejection of {videoKey} requested',
        id: 'b52ad',
      },
      { videoKey },
    );
    const failureText = intl.formatMessage(
      {
        defaultMessage: 'Rejection of {videoKey} failed',
        id: '5bcba',
      },
      { videoKey },
    );
    setActionMessage(response ? successText : failureText);

    setIsOpen(false);
  };

  const isInRejectedState = currentStatus === 'FAILED_QA';
  const handleRejectClick = () => !isInRejectedState && setIsOpen(true);

  const handleConfirmClick = () => rejectVideo();

  const handleReasonChange = (event) => setReason(event.target.value);

  const tooltip = intl.formatMessage(
    {
      defaultMessage: 'Reject {videoKey}',
      id: 'a9608',
    },
    { videoKey },
  );
  const disabledTooltip = intl.formatMessage(
    {
      defaultMessage: 'Reject {videoKey}. Already rejected',
      id: 'ac986',
    },
    { videoKey },
  );

  return (
    <>
      <ButtonIcon
        icon="Close"
        disabled={isInRejectedState}
        onClick={handleRejectClick}
        size={size}
        title={isInRejectedState ? disabledTooltip : tooltip}
        variant="secondary"
      />
      <Confirm
        id={`videoaction.reject.${videoKey}`}
        isOpen={isOpen}
        onCancel={() => setIsOpen(false)}
        onConfirm={handleConfirmClick}
        title={intl.formatMessage({
          defaultMessage: 'Reject Video Confirmation',
          id: '6d3df',
        })}
      >
        <Typography variant="headingSmall">
          <FormattedMessage
            defaultMessage="Are you sure you want to reject {videoKey}"
            values={{ videoKey }}
            id="5c9e3"
          />
        </Typography>
        <Typography variant="bodyMedium">
          <FormattedMessage
            defaultMessage="Note that comments can be seen by the provider which could be a customer"
            id="4e8a7"
          />
        </Typography>
        <TextField
          id="rejection-reason"
          label={intl.formatMessage({
            defaultMessage: 'Reason for rejection',
            id: 'b9050',
          })}
          onChange={handleReasonChange}
          value={reason}
          variant="secondary"
        />
      </Confirm>
    </>
  );
}

RejectVideo.propTypes = {
  currentStatus: PropTypes.string,
  size: PropTypes.string,
  videoKey: PropTypes.string.isRequired,
};
RejectVideo.defaultProps = {
  currentStatus: undefined,
  size: undefined,
};

export default { RejectVideo };
